import React, { ReactNode } from 'react'
import { motion } from 'framer-motion'

interface ScrollAnimationWrapperProps {
  animateIn: string
  children: ReactNode
  offset?: number
  delay?: number
  duration?: number
}

const animationVariants: { [key: string]: any } = {
  animate__fadeIn: {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  },
  animate__fadeInUp: {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  },
  animate__fadeInDown: {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0 },
  },
  animate__fadeInLeft: {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0 },
  },
  animate__fadeInRight: {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0 },
  },
  animate__zoomIn: {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  },
}

const ScrollAnimationWrapper: React.FC<ScrollAnimationWrapperProps> = ({
  animateIn,
  children,
  delay = 0,
  duration = 0.6,
}) => {
  const variants =
    animationVariants[animateIn] || animationVariants['animate__fadeIn']

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration, delay }}
      variants={variants}
    >
      {children}
    </motion.div>
  )
}

export default ScrollAnimationWrapper
